module.exports = __webpack_public_path__ + "static/magazine-1-mobile-cc92f12417eac460574b5e132e6122e3.jpg";